import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const HMXCheese = () => (
  <ArticleWrapper articleId="hmx_cheese">
    <div className="prose prose-invert mx-auto p-6">
      <h1>HMX Cheese</h1>
      {/* Add your HMX Cheese article content here */}
      <p>This is a placeholder article for the HMX Cheese switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default HMXCheese;
